import { Inject, Injectable, Optional, RESPONSE_INIT } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, MaybeAsync, UrlSerializer, UrlTree } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { ShopInfoService } from '../../core/services/shop-info.service';
import { catchError, of, switchMap } from 'rxjs';
import { PlatformInformationService } from '../../../../projects/platform-manager/src/public_api';

@Injectable({ providedIn: 'root' })
export class ParametersGuard implements CanActivate {
  constructor(
    private shopInfoService: ShopInfoService,
    private localizeRouterService: LocalizeRouterService,
    private serializer: UrlSerializer,
    private platformService: PlatformInformationService,
    @Optional() @Inject(RESPONSE_INIT) private response: ResponseInit
  ) {}

  canActivate(route: ActivatedRouteSnapshot): MaybeAsync<UrlTree> {
    const shopId = route.params['shopId'] ?? route.queryParams['shopId'];
    let url = '';
    if (Number.isInteger(+shopId)) {
      // in browser, clicking a link that opens a new tab
      // will run the route guard simultaneously with application initializers (initialNavigation: true for SSR hydration)
      // leading the hostname to be empty -> API urls can't be resolved.
      // We need to run the init() in chain to make sure the data is available here.
      return this.platformService.init().pipe(
        switchMap(() => {
          return this.shopInfoService.getLocationById(shopId).pipe(
            switchMap(shop => {
              if (route.params['partner']) {
                url = `/SKIHIREENTRY/partner-${route.params['partner']}/${shop.townSlugs[this.localizeRouterService.parser.currentLang]}/${shopId}/PRODUCTS`;
              } else {
                url = `/SKIHIREENTRY/${shop.townSlugs[this.localizeRouterService.parser.currentLang]}/${shopId}/PRODUCTS`;
              }
              const urlTree = this.serializer.parse(this.localizeRouterService.translateRoute(url) as string);
              const newQueryParams = { ...route.queryParams };
              delete newQueryParams['shopId'];
              urlTree.queryParams = newQueryParams;
              if (this.response?.headers instanceof Headers) {
                this.response.status = 301;
                this.response.headers.set('location', urlTree.toString());
              }
              return of(urlTree);
            }),
            catchError(e => {
              console.error(e);
              return of(this.getStartpage());
            })
          );
        })
      );
    } else {
      return this.getStartpage();
    }
  }

  getStartpage(): UrlTree {
    return this.serializer.parse(this.localizeRouterService.translateRoute(`/SKIHIREENTRY`) as string);
  }
}
